import { c as _c } from "react/compiler-runtime";
import Confirmation, { ConfirmationProps } from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
import { useDigitalProductActions } from '../hooks/use-digital-product-actions';
import { useOfferDigitalProductsCount } from '../hooks/use-offer-digital-products-count';
import { DigitalProductId, DigitalProductInterface } from '../types/digital-product-interface';
import { DeleteConfirmationLoader } from './delete-confirmation-loader';
export function useDigitalProductDeleteModal() {
  const $ = _c(11);
  const {
    opened,
    data,
    open,
    close,
    cleanData
  } = useModal(false, false);
  const digitalProductId = data;
  const {
    onDelete
  } = useDigitalProductActions();
  const {
    offerDigitalProductsCount
  } = useOfferDigitalProductsCount(digitalProductId);
  let t0;
  if ($[0] !== digitalProductId || $[1] !== onDelete) {
    t0 = async () => {
      if (!digitalProductId) {
        return;
      }
      await onDelete(digitalProductId);
    };
    $[0] = digitalProductId;
    $[1] = onDelete;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const deleteDigitalProduct = t0;
  const t1 = offerDigitalProductsCount?.count;
  let t2;
  if ($[3] !== cleanData || $[4] !== close || $[5] !== deleteDigitalProduct || $[6] !== digitalProductId || $[7] !== open || $[8] !== opened || $[9] !== t1) {
    t2 = {
      opened,
      digitalProductId,
      digitalProductLinkedOffersCount: t1,
      open,
      close,
      afterLeave: cleanData,
      deleteDigitalProduct
    };
    $[3] = cleanData;
    $[4] = close;
    $[5] = deleteDigitalProduct;
    $[6] = digitalProductId;
    $[7] = open;
    $[8] = opened;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
export function DigitalProductDeleteModal(t0) {
  const $ = _c(16);
  const {
    opened,
    digitalProductName,
    digitalProductLinkedOffersCount,
    onClose,
    onConfirm,
    afterLeave
  } = t0;
  const {
    t,
    tICU
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.offer.digital_product");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${digitalProductName ? `"${digitalProductName}"` : ""} ${t1}`;
  let t3;
  if ($[2] !== t || $[3] !== t2) {
    t3 = t("dashboard.actions.removed", {
      module: t2
    });
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== digitalProductLinkedOffersCount || $[6] !== digitalProductName || $[7] !== tICU) {
    t4 = digitalProductName && typeof digitalProductLinkedOffersCount === "number" ? <div className="text-text-primary text-base">{tICU("dashboard.offer.digital_product.remove_description_with_count", {
        digitalProductName,
        numberOfOffers: digitalProductLinkedOffersCount
      })}</div> : <DeleteConfirmationLoader />;
    $[5] = digitalProductLinkedOffersCount;
    $[6] = digitalProductName;
    $[7] = tICU;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== afterLeave || $[10] !== onClose || $[11] !== onConfirm || $[12] !== opened || $[13] !== t3 || $[14] !== t4) {
    t5 = <Confirmation status="error" opened={opened} onClose={onClose} onConfirm={onConfirm} afterLeave={afterLeave} toastCaption={t3} confirmationContent={t4} />;
    $[9] = afterLeave;
    $[10] = onClose;
    $[11] = onConfirm;
    $[12] = opened;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}